// extracted by mini-css-extract-plugin
module.exports = {"Panel":"css-modules_Panel__3SDMJ","Button":"css-modules_Button__q68vQ"};